import { PromptTemplateConfiguration } from "@/types/evaluate";

export enum LoopType {
  PROMPT = "prompt",
  WORKFLOW = "workflow",
}

export interface LoopConfiguration {
  loop_type: LoopType;
  prompt_config?: PromptTemplateConfiguration;
  workflow_config?: {
    workflow_id?: string;
    workflow_version_id?: string;
    name?: string;
    workflow_label_name?: string;
    workflow_version_number?: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    input_variables?: Record<string, any>;
    verbose?: boolean;
    return_all_outputs?: boolean;
  };
  end_condition_json_path?: string;
  max_iterations?: number;
  variable_mappings?: Record<string, string>;
}
